const { updateAvatar } = require('./avatar-generator-db')

export function generateImage(detail, htmlFc) {
  if(!detail) return
  updateAvatar(detail, htmlFc);
  
}